import { motion } from "framer-motion";
import { TIMELINE } from "../../data/content";

export const Timeline = () => (
  <section className="py-24 md:py-32 px-6 md:px-12" data-testid="timeline-section">
    <div className="max-w-7xl mx-auto">
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl">
        Vom Erstgespräch zur fertigen Website
      </h2>
      <p className="mt-5 text-base md:text-lg text-[#9AA3AF] max-w-2xl leading-relaxed">
        Realistische Zeitangaben statt Marketing-Versprechen. So sieht der typische Ablauf aus:
      </p>
      <ol className="mt-16 grid md:grid-cols-5 gap-px bg-[#2A303A] border border-[#2A303A]">
        {TIMELINE.map((t, i) => (
          <motion.li
            key={t.step}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08, ease: "easeOut" }}
            className="bg-[#101318] p-7"
            data-testid={`timeline-step-${t.step}`}
          >
            <span className="font-display text-sm font-bold text-[#2E5BFF]">Schritt {t.step}</span>
            <h3 className="font-display text-lg font-semibold mt-3">{t.title}</h3>
            <p className="text-xs font-semibold text-[#9AA3AF] uppercase tracking-wider mt-1">{t.time}</p>
            <p className="mt-3 text-sm text-[#9AA3AF] leading-relaxed">{t.text}</p>
          </motion.li>
        ))}
      </ol>
    </div>
  </section>
);
